import { AngularSvgIconModule } from "angular-svg-icon";
import { ClipboardModule } from "ngx-clipboard";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";

@Component({
  selector: "service-id",
  templateUrl: "service-id.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, GuidPipe, ClipboardModule],
})
export class ServiceId {
  protected subscriptionId = input.required<string>();
}
